import React,{Component} from 'react';
import './Services.css';

export default class Sevices extends Component{
    
    constructor(props){
    super(props)

        this.state={
            activeIndex:0
        }
    }

    btnClicked=(index)=>{
        this.setState({
        activeIndex:index
        })
    }

    renderSection= ()=>{
        if(this.state.activeIndex===0){
            return(
                <div className="hs-home-services-body nimated wow fadeInDown">
                <div className="hs-home-services-body-txt">
                    <h2>
                         Produtos de bordados exclusivos.
                    </h2>
                    <p>
                        Temos os melhores serviços de bordados que uma gráfica pode lhe ofercer, com a mais alta qualidade do mercado que uma gráfica pode lhe oferecer ou porpocinar.
                    </p>
                </div>
                <div className="hs-home-services-body-img">
                    <div className="hs-home-body-img"></div>
                </div>
            </div>
            );
        }
        else if(this.state.activeIndex===1){
            return(
                <div className="hs-home-services-body">
                <div className="hs-home-services-body-txt">
                    <h2>
                         Estampagens personalizadas ou prontas.
                    </h2>
                    <p>
                        As nossas Estampagens são da mais alta qualidade, a nivel nacional, feitas com os melhores materias de estampagens a nivel internacional e da mais alta qualidade. 
                    </p>
                </div>
                <div className="hs-home-services-body-img">
                    <div className="hs-home-body-img1"></div>
                </div>
            </div>
            )
        }
        else if(this.state.activeIndex===2){
            return(
                <div className="hs-home-services-body">
                <div className="hs-home-services-body-txt">
                    <h2>
                         As melhores decorações para o seu negócio.
                    </h2>
                    <p>
                        Temos vários serviços de decorações para a sua empresa e para si, com detalhes super criativos e criados por proficionais da mais talta qualidade e com muita experiencia.
                    </p>
                </div>
                <div className="hs-home-services-body-img">
                    <div className="hs-home-body-img2"></div>
                </div>
            </div>
            )
        }
        else if(this.state.activeIndex===3){
            return(
                <div className="hs-home-services-body">
                <div className="hs-home-services-body-txt">
                    <h2>
                         Sirigrafia da mais alta qualidade.
                    </h2>
                    <p>
                        Sirigrafia da mais mais alta qualiade, feitas com os melhores materias de concepção de produtos de sirigrafia, trabalhamos com materias de da mais alta qualiadade. 
                    </p>
                </div>
                <div className="hs-home-services-body-img">
                    <div className="hs-home-body-img3"></div>
                </div>
            </div>
            )
        }
        else if(this.state.activeIndex===4){
            return(
                <div className="hs-home-services-body">
                <div className="hs-home-services-body-txt">
                    <h2>
                         Os nossos produtos são totalmente exclusivos
                         Offesets de primaira criativos e originais.
                    </h2>
                    <p>
                        Fazemos Offesets de primaira qualidade, com muita criativadade e experiencia de concepção de Offesets, usamos materias mais alta qualidade e supers resistentes.
                    </p>
                </div>
                <div className="hs-home-services-body-img">
                    <div className="hs-home-body-img4"></div>
                </div>
            </div>
            )
        }
      }

    render(){
        return(
            <div className="hs-home-div">
                <div className="hs-home-services-main nimated wow fadeInRight">
                    <div className="hs-home-services">
                        <button  
                            className={this.state.activeIndex === 0 ? 'active' : ''}
                            onClick={()=>this.btnClicked(0)}
                            active={this.state.activeIndex===0}
                        >
                            Bordado
                        </button>
                        <button 
                            className={this.state.activeIndex === 1 ? 'active' : ''}
                            onClick={()=>this.btnClicked(1)}
                            active={this.state.activeIndex===1}
                        >
                            Estampagem
                         </button>

                        <button 
                            className={this.state.activeIndex === 2 ? 'active' : ''}
                            onClick={()=>this.btnClicked(2)}
                            active={this.state.activeIndex===2}
                        >
                            Decoração
                        </button>
                        <button 
                            className={this.state.activeIndex === 3 ? 'active' : ''}
                            onClick={()=>this.btnClicked(3)}
                            active={this.state.activeIndex===3}
                        >
                            Sirigrafia
                        </button>
                        <button 
                            className={this.state.activeIndex === 4 ? 'active' : ''}
                            onClick={()=>this.btnClicked(4)}
                            active={this.state.activeIndex===4}
                        >
                            Offset
                        </button>
                    </div>
                    {this.renderSection()}
                </div>
            </div>
        );
    }
}